




































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { Table } from "@/utils/decorator";
import FileUpload from "@/components/scope/file-upload.vue";
import { priceRulesEl } from "@/utils/verify";

const purchase = namespace("purchase");

@Component({
  components: { FileUpload }
})
export default class RegisterInvoice extends Vue {
  @purchase.State makeInvoiceBtnLoading;
  @Prop()
  show: boolean;
  @Prop({ default: () => ({}) })
  paymentData: any;
  formData: any = {
    invoiceAmount: "",
    invoiceCategoryCode: "",
    invoiceNo: "",
    invoiceUrl: "",
    invoiceType: "2",
    orderNo: ""
  };
  showFlag: boolean = true;
  formDataRules: any = {
    invoiceAmount: [
      {
        required: true,
        message: "请输入开票金额"
      },
      { validator: this.checkPrice, trigger: "blur" }
    ],
    invoiceCategoryCode: [{ required: true, message: "请输入发票代码", trigger: "blur" }],
    invoiceNo: [{ required: true, message: "请输入发票号码", trigger: "blur" }]
  };
  handleCancel() {
    this.$emit("update:show", false);
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  handleOpen() {
    this.formData.invoiceCategoryCode = "";
    this.formData.invoiceNo = "";
    this.formData.invoiceUrl = "";
    this.showFlag = false;
    this.$nextTick(() => {
      this.showFlag = true;
    });
    this.formData.invoiceAmount = this.paymentData.purchaseAmount || "";
  }
  handleConfirm() {
    (this.$refs.invoiceFormRef as any).validate(valid => {
      if (valid) {
        let param = Object.assign(this.formData, {
          orderNo: this.paymentData.purchaseNo
        });
        this.$emit("confirmBtnClick", Object.assign({}, this.formData));
      }
    });
  }
}
